module.exports = __webpack_public_path__ + "static/media/maf-50.beef271b.png";